import React from 'react';

import type { TypographyProps } from './types';
import { StyledHeadingCentered } from './StyledComponents';

export const HeadingCentered = ({
  children,
  testID,
  ...rest
}: TypographyProps): React.ReactElement => (
  <StyledHeadingCentered data-testid={testID} {...rest}>
    {children}
  </StyledHeadingCentered>
);
